{
  "GenericModal_PromptMessage": "Möchten Sie dieses Fenster wirklich schließen? Alle geänderten Konfigurationen gehen beim Schließen verloren.",
  "GenericModal_PromptConfirm": "Ja",
  "GenericModal_PromptCancel": "Stornieren",
  "NAME": "GenericModal"
}